<template>
  <surg-add v-if="surgery" :editSurgery="surgery" />
</template>

<script>
import SurgAdd from "./SurgAdd.vue";
import {
  insuranceQuestions,
  getShortCareServices
} from "../../../utilities/surgery-questions.js";
import { getSurgeryDocuments } from "../../../utilities/download-document.js";

export default {
  components: { SurgAdd },
  name: "SurgEdit",
  data() {
    return {
      insuranceQuestions,
      surgery: null,
      documents: [
        {
          type: "clinic-confirm-agreement",
          files: [],
          title: "הסכמה מדעת לפעולה*",
          note: `לתשומת ליבך, ע"פ הנחיות משרד הבריאות, מסמך הסכמה מדעת בתוקף עד 30 יום מיום חתימת המטופל.`
        },
        {
          type: "reference-document",
          files: [],
          title: "סיכום ייעוץ לקראת ניתוח*",
          note:
            "*לאור דרישות קופות החולים וחברות הביטוח, יש לצרף מסמך סיכום ייעוץ המפנה לניתוח."
        },
        {
          type: "ext-imaging-diagnosis",
          files: [],
          title: "פענוח בדיקות הדמייה*",
          note: `ע"פ נהלי הקופה, קוד הניתוח הנבחר מחייב העלאת פענוח בדיקת הדמייה.`
        },
        { type: "", files: [], title: "קבצים נוספים" }
      ]
    };
  },
  methods: {
    getShortCareServices
  },
  async mounted() {
    const res = await this.$API.getSurgeryInfo(this.$route.params.id);
    const resOrders = await this.$API.getSurgeryOrders(this.$route.params.id);

    if (res && res.status == "OK") {
      let surg = res.message.surgery;
      // this.documents = res.message.documents;

      let editGender;
      if (
        res.message.patient.gender === "male" ||
        res.message.patient.gender === "זכר"
      ) {
        editGender = "male";
      } else if (
        res.message.patient.gender === "female" ||
        res.message.patient.gender === "נקבה"
      ) {
        editGender = "female";
      } else {
        editGender = "";
      }
      // documents
      const resDoc = await getSurgeryDocuments(this.$route.params.id);
      if (resDoc) {
        resDoc.forEach((doc, i) => {
          this.documents[i].files = doc.files;
        });
      }

      // 1 - current_surgery && 8 - insurance_surgery
      let selected_surgery = [];
      let insurance_surgery = [];
      if (resOrders && resOrders.status == "OK" && resOrders.data?.orders) {
        const current_surgery = resOrders.data?.orders;
        current_surgery.map(s => {
          if (s.tafnit_code === "9000") return;

          let insurance = s.insurance_name;
          if (
            s.tafnit_code == 1 &&
            insurance !== "כללית מושלם" &&
            insurance !== "פרטי"
          ) {
            insurance = "חברת ביטוח";
          }
          insurance_surgery.push({
            insurance_type: insurance,
            // category: insurance.surgery_category,
            code: s.insurance_procedure,
            notes: s.notes
          });

          const duration = s.duration
            ? this.$moment.utc(s.duration * 1000).format("HH:mm")
            : "HH:mm";
          selected_surgery.push({
            // surgery_category: s.surgery_category ?? "",
            id: s.id,
            is_primary: s.is_primary || "",
            code_name_clinical: s.icd9_procedure,
            code_name_hospital: s.type,
            duration: duration,
            default_surgery_duration: duration,
            side: s.side ?? "",
            insurance_type: insurance,
            newSpecialInsuranceCode: true,
            additionalInfo: {
              status: s.status,
              surgery_fee: s.surgery_fee,
              reference_id: s.reference_id,
              name: "",
              foreign_id: s.foreign_id,
              fee: s.fee,
              expiration_date: s.expiration_date
            }
          });
        });
      }
      //
      let current_diagnosis = [];
      let past_diagnosis = [];
      if (surg.diagnosis) {
        const diagnosis = JSON.parse(surg.diagnosis);
        // 3 - current_diagnosis
        if (diagnosis.current && diagnosis.current.length) {
          diagnosis.current.map(diagnosis => {
            current_diagnosis.push({
              side: diagnosis.side ?? "",
              code: diagnosis.diagnosis_number,
              name: diagnosis.diagnosis_name,
              notes: diagnosis.notice
            });
          });
        }
        // 4 - past_diagnosis
        if (diagnosis.past && diagnosis.past.length) {
          diagnosis.past.map(diagnosis => {
            past_diagnosis.push({
              side: diagnosis.side ?? "",
              diagnosis_number: diagnosis.diagnosis_number,
              diagnosis_name: diagnosis.diagnosis_name,
              notice: diagnosis.notice
            });
          });
        }
      }

      //
      let medication_sensitivity = [];
      let material_sensitivity = [];
      const sensitivity = JSON.parse(res.message.patient.sensitivity);
      if (sensitivity) {
        // 6 - medication_sensitivity
        if (sensitivity.medication && sensitivity.medication.length) {
          sensitivity.medication.map(sens => {
            medication_sensitivity.push({
              reaction: sens.response,
              severity: sens.severity,
              name: sens.medication,
              notes: sens.notice
            });
          });
        }
        // 7 - material_sensitivity
        if (sensitivity.material && sensitivity.material.length) {
          sensitivity.material.map(material => {
            material_sensitivity.push({
              reaction: material.response,
              severity: material.severity,
              name: material.material_name,
              notes: material.notice
            });
          });
        }
      }

      let birth_date;
      if (res.message.patient.birthDate) {
        birth_date = this.$moment(
          res.message.patient.birthDate,
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");
      }

      this.surgery = {
        id_num: res.message.patient.passport,
        start_date: surg.start_date,
        first_name: res.message.patient.firstName,
        last_name: res.message.patient.lastName,
        birth_date: birth_date,
        parent_name: res.message.patient.apotropos || "",
        parental_status: res.message.surgery.parental_status || "",
        phone: res.message.patient.phone || "",
        phone2: res.message.patient.phone2 || "",
        lang: res.message.patient.language || "",
        email: res.message.patient.email || "",
        gender: editGender,
        selected_surgery: selected_surgery,
        treatment_history: surg.indication,
        current_diagnosis: current_diagnosis,
        past_diagnosis: past_diagnosis,
        checkbox_past_diagnosis: surg.checkbox_past_diagnosis ? true : false,
        background_diagnosis: "",
        phisycal_check: surg.physicalExam,
        no_drug_sens: res.message.patient.checkbox_medication_sensitivity
          ? true
          : false,
        no_material_sens: res.message.patient.checkbox_material_sensitivity
          ? true
          : false,
        medication_sensitivity: medication_sensitivity,
        material_sensitivity: material_sensitivity,
        insurance_surgery: insurance_surgery,
        assistant: surg.assistant_status,
        assistant_name: surg.assistant_name,
        hospitalization: surg.hospitalization,
        anesthesia: surg.anesthesia,
        xray_type: surg.xray_type,
        select_frozen_cut: surg.frozen_cut,
        requests: {
          monitoring_request: surg.monitoring_request == "כן" ? true : false,
          blood: surg.blood == "כן" ? true : false,
          icu: surg.icu == "כן" ? true : false,
          tee_request: surg.tee_request == "כן" ? true : false,
          navigation_request: surg.navigation_request == "כן" ? true : false
        },
        doctor_fee: surg.doctor_fee,
        insurance_type: surg.insurance_name,
        resources: surg.resources,
        notes: surg.notes,
        handle_insurance_claim_by_hmc: surg.handle_insurance_claim_by_hmc,
        files: this.documents,
        confirm_agreement: this.documents[0].files.length ? "true" : "false",
        payment_token: surg.payment_token,
        pre_surgery_override: surg.preSurgery_status === "pre_needed"
      };

      if (res.message.patient.passport_type) {
        this.surgery.passport_type = res.message.patient.passport_type;
      }

      const tmpPayType = this.surgery.insurance_type;
      const newInsurance = this.getShortCareServices(tmpPayType);
      this.surgery.insurance_type = newInsurance;
      surg.insurance_name = newInsurance;

      // isInsuranceCompany
      const found = this.insuranceQuestions.insuranceCompanyOptions.some(
        i =>
          i.value === surg.insurance_name ||
          i.value === surg.secondary_insurance_name
      );
      this.surgery.isInsuranceCompany = found ? "true" : "false";

      // insurance_type & insuranceCompany & payType
      const insuranceOptions = insuranceQuestions.careServicesOptions;

      const insuranceCompanyOptions = this.insuranceQuestions
        .insuranceCompanyOptions;

      const foundInsurance = insuranceOptions.find(
        option => option.value == surg.insurance_name
      );

      if (foundInsurance) {
        this.surgery.insurance_type = foundInsurance.value;
        this.surgery.insuranceCompany = surg.secondary_insurance_name;
        this.surgery.payType = tmpPayType;
      } else {
        const foundInsuranceCompany = insuranceCompanyOptions.find(
          option => option.value == surg.insurance_name
        );
        if (foundInsuranceCompany) {
          this.surgery.insurance_type = this.getShortCareServices(
            surg.secondary_insurance_name
          );
          this.surgery.insuranceCompany = foundInsuranceCompany.value;
          this.surgery.payType = "חברת ביטוח";
        } else {
          this.surgery.payType = surg.insurance_name;
          if (surg.secondary_insurance_name) {
            const foundInsurance = insuranceOptions.find(
              option =>
                option.value ==
                this.getShortCareServices(surg.secondary_insurance_name)
            );
            if (foundInsurance)
              this.surgery.insurance_type = foundInsurance.value;
            else this.surgery.insurance_type = "ללא קופה";
          }
        }
      }

      if (
        selected_surgery.length === 1 &&
        selected_surgery[0].code_name_hospital === "1 > RHINOPLASTY" &&
        surg.secondary_insurance_name === "כללית מושלם"
      ) {
        this.surgery.payType = "כללית מושלם";
      }
    }
  }
};
</script>
